import axios from 'axios';
import getEnv from './getEnv';
import getVersion from './getVersion';
import loadSDK from './loadSDK';
import Logger from './logger';
import getUA from './getUA';
import injectScript from './injectScript';

function isFunc(v) {
  return typeof v === 'function';
}

function emptyFunc() {}

/**
 * 包装一个方法为 Promise
 * @param {*} func 执行方法
 * @param  {...any} args 类似与 Function.prototype.call 方法参数，第一个为执行作用域
 */
function warpFuncPromise(func, ...args) {
  return new Promise((resolve, reject) => {
    try {
      const handle = func.call(...args);
      // 假如是有 then 方法，认为是异步方法
      if (handle && isFunc(handle.then)) {
        handle.then(resolve).catch(reject);
      } else {
        // 同步方法
        resolve(handle);
      }
    } catch (err) {
      reject(err);
    }
  });
}

const util = {
  getEnv,
  getVersion,
  loadSDK,
  isFunc,
  Logger,
  axios: axios.create(),
  getUA,
  injectScript,
  warpFuncPromise,
  emptyFunc
};

export default util;
// TODO 这里先放着，用手动 import 的方式来做，后面考虑实现类似 webpack require.context 的方式来加载目录下的文件
